// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__eI-2T"};